import { contextoCultivoLegado } from '../services/ciclosCultivoService';
import { operationalPlantingToLegacyPlot } from '../services/operationalPropertiesService';
import { getCropLifecycle } from '../utils/cropLifecycle';

export function plantingLifecycle(planting, referenceDate) {
  if (planting?.status === 'cancelado') return 'canceled';
  if (planting?.status === 'colhido') return 'harvested';
  return getCropLifecycle(planting, referenceDate);
}

export function getPlotPlantingView(plot = {}, referenceDate) {
  let records;
  if (Array.isArray(plot.plantios)) records = plot.plantios;
  else if (Array.isArray(plot.ciclos_cultivo)) records = plot.ciclos_cultivo;
  else if ('ciclo_atual' in plot || 'ultimo_ciclo' in plot) records = [plot.ciclo_atual, plot.ultimo_ciclo];
  else records = [contextoCultivoLegado(plot).ultimoCiclo];

  const plantings = [...new Map(records.filter(Boolean)
    .filter(item => item.status !== 'cancelado')
    .map(item => [String(item.id ?? `${item.data_plantio}:${item.cultura}`), item])).values()]
    .sort((a, b) => String(b.data_plantio || '').localeCompare(String(a.data_plantio || '')));
  const active = plantings.find(item => plantingLifecycle(item, referenceDate) === 'active');
  const planned = plantings.find(item => plantingLifecycle(item, referenceDate) === 'planned');
  const current = active || planned || null;
  return {
    current,
    history: plantings.filter(item => item !== current),
    historyUnavailable: plot.temHistorico === true && plantings.length === 0,
  };
}

export function plantingDetailPlot(plot, planting, property = {}) {
  if (!planting?.data_plantio || !String(planting.cultura || '').trim()) return null;
  if (plot._operationalPhysical || Array.isArray(plot.plantios)) {
    const legacyId = plot.talhao_legado_principal_id ?? (plot._legacyCompatibilityMissing === false ? plot.id : null);
    return operationalPlantingToLegacyPlot({ ...plot, id: plot._physicalPlotId ?? plot.id, talhao_legado_principal_id: legacyId }, planting, property);
  }
  return {
    ...plot,
    nome: planting.nome_legado || plot.nome,
    cultura: planting.cultura,
    variedade: planting.variedade || '',
    data_plantio: planting.data_plantio || null,
    data_colheita: planting.data_colheita || null,
    data_colheita_prevista: planting.data_colheita_prevista || null,
    observacoes: planting.observacoes || '',
    status: planting.status,
    ciclo_atual: planting,
    _plantingId: planting.id,
  };
}
